/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/modules/dashboard/components/widget/dashboard.widget.component.ts.
 */
import {Component, Input} from '@angular/core';
import {AppMobileService} from '../../../../services/app.mobile.service';

/**
 * Zweck: Beschreibt class DashboardWidgetComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    selector: 'dashboard-widget',
    templateUrl: 'dashboard.widget.component.html',
    styleUrls: ['dashboard.widget.component.scss'],
    standalone: false
})
export class DashboardWidgetComponent {
  @Input() footer_enabled = false;
  @Input() isMobile = false;

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public msvc: AppMobileService) {
  }
}
